import React, { useEffect } from "react";
import {
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  LogoLoader,
  NewTableAdv,
  StatusTags,
  useFormHandler,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { DropDownoptionsquickbooks } from "../../../../assets/data/projectData";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { qbApiStart, resetAllQBData } from "../../../../redux/slices/quickBooks/quickBooksSlice";

const Timesheets = ({ setActiveTab, dropdowns }) => {
    const navigate = useNavigate();
  const dispatch = useDispatch();
  const { timesheets, loading } = useSelector((state) => state.quickBooks);

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Placement: "",
    documentType: "",
    status: "",
  });
  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
      sortable: false,
    },

    {
      key: "client",
      label: "Client",
      sortable: false,
    },
    {
      key: "timeSheetId",
      label: "Timesheet Id",
      sortable: false,
    },
    {
      key: "bussinessUnit",
      label: "Bussiness Unit",
      sortable: false,
    },
    {
      key: "fromData",
      label: "From Date",
      sortable: false,
    },
    {
      key: "toDate",
      label: "To Date",
      sortable: false,
    },
    {
      key: "totalHours",
      label: "Total Hours",
      sortable: false,
    },
  ];

  const rowdata = [
    {
      employeeName: "",
      client: "",
      timeSheetId: "",
      bussinessUnit: "",
      fromData: "",
      toDate: "",
      totalHours: "",
    },
    {
      employeeName: "",
      client: "",
      timeSheetId: "",
      bussinessUnit: "",
      fromData: "",
      toDate: "",
      totalHours: "",
    },
    {
      employeeName: "",
      client: "",
      timeSheetId: "",
      bussinessUnit: "",
      fromData: "",
      toDate: "",
      totalHours: "",
    },
  ];

    const fetchTimesheetsFromQb = async () => {
      dispatch(
        qbApiStart({
          method: "GET",
          entity: "timesheets",
          // body: {
          //
          // },
        })
      );
  };
  useEffect(() => {
    fetchTimesheetsFromQb();
  },[])
    const rowData2 =
    (timesheets || []).map((item) => ({
      employeeName: item?.EmployeeRef?.name||"-",
      client: item?.CustomerRef?.name||"-",
      timeSheetId: item?.Id || "-",
      bussinessUnit: "-",
      fromData: "",
      toDate: "",
      totalHours: item?.Hours || "-",
    })) || [];
  // const mappedRows = mapTableRows(rowdata, columns);
  const mappedRows = mapTableRows(rowData2, columns);
  const handleSearch = () => {
    setActiveTab(Number(formData.Timesheets));
  };
  return (
    <div>
      <Backdrop isOpen={loading}>
              <LogoLoader />
            </Backdrop>
      <NewTableAdv
        rows={mappedRows}
        columns={columns}
        showCheckbox
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className=" flex gap-3 flex-wrap m-2 items-center ">
                  <DevNote>
                                      <div style={{ display: "flex", gap: "6px" }}>
                                        <button
                                          onClick={() => fetchTimesheetsFromQb()}
                                          style={{
                                            background: "none",
                                            border: "none",
                                            padding: "4px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M12 21C7.02944 21 3 16.9706 3 12C3 9.69494 3.86656 7.59227 5.29168 6L8 3M12 3C16.9706 3 21 7.02944 21 12C21 14.3051 20.1334 16.4077 18.7083 18L16 21M3 3H8M8 3V8M21 21H16M16 21V16"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                        </button>
                                        <button
                                          onClick={() => dispatch(resetAllQBData())}
                                          style={{
                                            background: "none",
                                            border: "none",
                                            padding: "4px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M10 11V17"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M14 11V17"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M4 7H20"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                                              stroke="#000000"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </DevNote>
                  <FormFieldSet
                    type="text"
                    noTitle
                    placeholder="Invoice No, Client, Employee"
                    value={formData.Search || ""}
                    onChange={(value) => handleChange("Search", value)}
                    error={errors.Search}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Timesheets"
                    value={formData.Timesheets || ""}
                    // onChange={(value) => setActiveTab(value)}
                    onChange={(value) => handleChange("Timesheets", value)}
                    error={errors.Timesheets}
                    options={dropdowns}
                  />
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Select Status"
                    value={formData.status || ""}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                    options={""}
                    showSearch
                  />
                 
                    <Button title="Search" onClick={handleSearch} />
                
                    <Button
                      title="QB Integration Profiles"
                      color="info"
                      onClick={() =>
                        navigate("/quickbooks/qb-integration-profile")
                      }
                    />
                  </div>
                
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default Timesheets;
